import { restManager } from '@/plugin/restManager.js';

function load(method, api, param, header) {
  return new Promise((resolve, reject) => {
    api = process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + api;

    let axios;
    switch (method) {
      case 'get':
        axios = restManager.get(api, param, true, true, { headers: header });
        break;
      case 'post':
        axios = restManager.post(api, param, true, true, { headers: header });
        break;
      default:
        break;
    }
    axios
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/** 위젯 데이타 */
export function getWidgetData(method, api, param, header) {
  return load(method, api, param, header);
}

/** Dashboard 목록 */
export function getDashboardDatas() {
  return restManager.dashboard.get('/v1/console/dashboards/account');
}

/** 상품 목록 */
export function getResourceTypeDatas(header) {
  return load(
    'get',
    '/cloudmonitorings/product/v1/console/product-sub-types',
    { logMetricYn: 'N', useYn: 'Y' },
    header
  );
}

/** 모니터링 대상 정보 */
export function getProductSummary(resourceType) {
  return load(
    'get',
    '/cloudmonitorings/product/v1/console/products/summaries',
    { includeTags: 'N', page: 0, size: 0 },
    { 'X-ResourceType': resourceType }
  );
}

/** 주요 성능 항목 */
export function getSummaryMetricDatas(resourceType, params) {
  return load('post', '/cloudmonitorings/product/v1/console/summary-metrics', params, {
    'X-ResourceType': resourceType
  });
}

/** 성능항목 목록(metrics) */
export function getMetricDatas(resourceType, params) {
  return load('post', '/cloudmonitorings/product/v1/console/metrics', params, {
    'X-ResourceType': resourceType
  });
}

/** 개별항목 목록 */
export function getObjectDatas(subType, resourceType, params) {
  let path = subType === '' ? '' : '/' + subType;
  return load('post', '/cloudmonitorings/product/v1/console/objects' + path, params, {
    'X-ResourceType': resourceType,
    'X-Cmp-ResourceAuth': 'N'
  });
}

/** 상품별 모니터링 상태 카운트 */
export function getProductMonitoringCount(header, param = {}) {
  return load('get', '/cloudmonitorings/product/v1/console/products/count', param, header);
}

/** Down 된 상품의 리트스 목록 가져오기 */
export function getProductStatusDatas(status, header) {
  return load('get', '/cloudmonitorings/product/v1/console/products/count/' + status, {}, header);
}

/** 프로젝트 권한 체크 */
export function checkAccountAuth(header) {
  return new Promise((resolve, reject) => {
    load('get', '/cloudmonitorings/system/v1/console/accounts/check-authorization', null, header)
      .then((res) => {
        if (res.authorizationCheckResult === 'Allow') {
          resolve(true);
        } else {
          reject(getMessage(res));
        }
      })
      .catch((error) => reject(error));
  });
}

/** 상품 유형별 권한 체크 */
export function checkResourceTypeAuth(resourceType, header) {
  let h = Object.assign({ 'X-ResourceType': resourceType }, header);
  return new Promise((resolve, reject) => {
    load('get', '/cloudmonitorings/product/v1/console/product-sub-types/check-authorization', {}, h)
      .then((res) => {
        if (res.authorizationCheckResult === 'Allow') {
          resolve(true);
        } else {
          reject(getMessage(res));
        }
      })
      .catch((error) => reject(error));
  });
}

/** 개별 자원에 대한 IAM 권한 체크 */
export function checkProductAuth(resourceType, productResourceIds, header) {
  let params = {
    productResourceIds: productResourceIds,
    actionName: 'MonitorView'
  };
  let h = Object.assign({ 'X-ResourceType': resourceType }, header);

  return new Promise((resolve, reject) => {
    load('post', '/cloudmonitorings/product/v1/console/products/check-authorization', params, h)
      .then((res) => {
        if (res.authorizationCheckResult === 'Allow') {
          resolve(true);
        } else {
          reject(getMessage(res));
        }
      })
      .catch((error) => reject(error));
  });
}

function getMessage(data) {
  let message = {
    code: 'AccessDenied',
    params: [
      {
        name: 'service',
        value: data.serviceName
      },
      {
        name: 'action',
        value: data.actionName
      }
    ]
  };
  return message;
}
